// This function allow to reference async chunks
__webpack_require__.miniCssF = (chunkId) => {
	// return url for filenames based on template
	return "static/css/" + chunkId + "." + {"44":"7c6361b1","60":"09e7a8ac","154":"bc5b0b75","163":"1b91a47c","213":"96eb5ce9","335":"163b0a23","418":"bc5b0b75","419":"bc5b0b75","564":"bc5b0b75","628":"b28e7e4d"}[chunkId] + ".chunk.css";
};